import customerApi from '@/api/customer'
import { animationConfigGetByUserId } from '@/api/userConfig'
import { enums } from '@/main'

import { UPDATE_CUSTOMER_DETAIL, CLEAR_CUSTOMER_DETAIL } from './mutation-types'

export default {
  state: {
    customerDetail: {}
  },
  mutations: {
    [UPDATE_CUSTOMER_DETAIL](state, payload) {
      state.customerDetail = Object.assign({}, state.customerDetail, payload)
    },
    [CLEAR_CUSTOMER_DETAIL](state) {
      state.customerDetail = {}
    }
  },
  actions: {
    getCustomerDetailByUserId({ commit }, userId = 0) {
      const req = [customerApi.getCustomerDetailByUserId(userId), animationConfigGetByUserId(userId)]
      return Promise.all(req).then(res => {
        const customerDetail = res[0]
        customerDetail.configAnimation = res[1]
        if (customerDetail.configAnimation.show) {
          customerDetail.configAnimation.animMap[3].material = { type: enums.PBMaterialType.MT_MID_LINE }
        } else {
          customerDetail.configAnimation.animMap = [
            { material: { type: enums.PBMaterialType.MT_GRANDSTAND } },
            { material: { type: enums.PBMaterialType.MT_SITE } },
            { material: { type: enums.PBMaterialType.MT_FENCE } },
            { material: { type: enums.PBMaterialType.MT_MID_LINE } }
          ]
        }
        commit(UPDATE_CUSTOMER_DETAIL, customerDetail)
      })
    },
    getCustomerDetailById({ commit }, id = 0) {
      return customerApi.getCustomerDetailById(id).then(customerDetail => {
        commit(UPDATE_CUSTOMER_DETAIL, customerDetail)
      })
    },
    clearCustomerDetail({ commit }) {
      commit(CLEAR_CUSTOMER_DETAIL)
    }
  },
  getters: {
    customer(state) {
      return state.customerDetail.customer
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/customer.js